<div class="row align-items-center">
  <div class="col-auto pe-1">
    <app-avatar
      [firstName]="item().holder.first_name"
      [lastName]="item().holder.last_name"
      [size]="'sm'"></app-avatar>
  </div>
  <div class="col">
    @if (item().type === CardType.Personal) {
      <div class="title">{{ item().holder.first_name }} {{ item().holder.last_name }}</div>
    } @else {
      <div class="title">{{ item().name }}</div>
    }
  </div>
  @if (isRecurring() && item().recurring_rule_id) {
    <div
      class="col-auto ms-auto"
      title="Card has a recurring rule">
      <i class="pays-svg-icon ic-card-plus"></i>
    </div>
  }
</div>
